import styled, { css } from 'styled-components/macro'
import { ifProp, ifNotProp } from 'styled-tools'
import { rgba, color } from '../../../utils/styles';

const hightlightBar = props => props.error || props.focused
const hightlightBarColor = ifProp('error', color('error'), color('base'))

const InputWrapper = styled.div`
  position: relative;
  display: inline-flex;

  ${ifProp('full', css`
    width: 100%;
  `)}

  ${ifProp('disabled', css`
    opacity: .4;
    cursor: not-allowed;
  `)}

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    pointer-events: none;
  }

  &::before {
    transition: border-bottom-color 200ms ease-out;
    border-bottom: 1px ${ifProp('disabled', 'dotted', 'solid')} ${rgba('base', 0.4)};
    z-index: 2;
  }

  ${ifNotProp('disabled', css`
    &:hover::before{
      border-bottom: 2px solid ${rgba('base', 0.7)};
    }
  `)}

  &::after {
    transform: ${ifProp(hightlightBar, 'scaleX(1)', 'scaleX(0)')};
    transition: border-bottom-color 200ms ease-out,
                transform 200ms ease-out;
    border-bottom: 2px solid ${hightlightBarColor};
    z-index: 3;
  }
`

export default InputWrapper
